import { useState } from 'react';

import Image from 'next/image';

import { Heading, Icon, Modal, Paragraph, Tabs } from '@zillow/constellation-10';
import { IconInfoFilled } from '@zillow/constellation-icons';

import { useScreenSize } from '../../../hooks/useScreenSize';

import ApplicantSummaryMWeb from '../../../assets/applicationSample/mweb/ApplicantSummaryMWeb.png';
import BackgroundCheckMWeb from '../../../assets/applicationSample/mweb/BackgroundCheckMWeb.png';
import CreditReportMWeb from '../../../assets/applicationSample/mweb/CreditReportMWeb.png';
import ApplicantSummaryWeb from '../../../assets/applicationSample/web/ApplicantSummaryWeb.png';
import BackgroundCheckWeb from '../../../assets/applicationSample/web/BackgroundCheckWeb.png';
import CreditReportWeb from '../../../assets/applicationSample/web/CreditReportWeb.png';

const ApplicationSampleModal = ({ onClose }: { onClose: () => void }) => {
  const { isScreenMobile } = useScreenSize();

  const [state, setState] = useState({ selected: 'summary-tab' });

  return (
    <Modal
      open={true}
      onOpenChange={(open) => !open && onClose()}
      header={<Heading level={6}>Application sample</Heading>}
      size={{ base: 'fullScreen', md: 'md' }}
      body={
        <>
          <Paragraph css={{ paddingBottom: '400' }}>
            <Icon css={{ color: 'icon.accent.blue.strong' }}>
              <IconInfoFilled />
            </Icon>{' '}
            These documents are for viewing purposes only.
          </Paragraph>
          <Tabs.Root
            appearance="file"
            selected={state.selected}
            onSelectedChange={(selected: string) => setState({ selected })}
          >
            <Tabs.List aria-label="sample-application-files">
              <Tabs.Tab value="summary-tab">Applicant Summary</Tabs.Tab>
              <Tabs.Tab value="credit-tab">Credit Report</Tabs.Tab>
              <Tabs.Tab value="background-tab">Background Check</Tabs.Tab>
            </Tabs.List>
            <Tabs.Panel
              value="summary-tab"
              css={{ overflow: 'scroll', maxHeight: { base: 'calc(100vh - 235px)', lg: '612px' } }}
            >
              <Image
                src={isScreenMobile ? ApplicantSummaryMWeb : ApplicantSummaryWeb}
                alt="Applicant Summary sample"
                style={{ width: '100%', height: 'auto', display: 'block' }}
              />
            </Tabs.Panel>
            <Tabs.Panel
              value="credit-tab"
              css={{ overflow: 'scroll', maxHeight: { base: 'calc(100vh - 235px)', lg: '612px' } }}
            >
              <Image
                src={isScreenMobile ? CreditReportMWeb : CreditReportWeb}
                alt="Credit Report sample"
                style={{ width: '100%', height: 'auto', display: 'block' }}
              />
            </Tabs.Panel>
            <Tabs.Panel
              value="background-tab"
              css={{ overflow: 'scroll', maxHeight: { base: 'calc(100vh - 235px)', lg: '612px' } }}
            >
              <Image
                src={isScreenMobile ? BackgroundCheckMWeb : BackgroundCheckWeb}
                alt="Background Check sample"
                style={{ width: '100%', height: 'auto', display: 'block' }}
              />
            </Tabs.Panel>
          </Tabs.Root>
        </>
      }
    />
  );
};

export default ApplicationSampleModal;
